import domReady from '@wordpress/dom-ready';

domReady(() => {
  const sectionWrappers = document.querySelectorAll(
    '[data-section-wrapper="true"]'
  );

  if (sectionWrappers.length === 0) {
    return;
  }

  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  if (prefersReducedMotion) {
    sectionWrappers.forEach((wrapper) => {
      wrapper.children[0].classList.add('active');
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.children[0].classList.add('active');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold:  0,
      rootMargin: '-10% 0px -10% 0px',
    }
  );

  sectionWrappers.forEach((wrapper) => {
    observer.observe(wrapper);
  });
});
